import { FQF_TIME_UNITS, formatDurationToMilliseconds, formatDurationToUnit, getDefaultUnit } from 'customer-data-filters-ui/utils/durationUtilities';
import I18n from 'I18n';
import { useState } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UISelect from 'UIComponents/input/UISelect';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorDateDurationInput = props => {
  const {
    'data-selenium-test': dataSeleniumTest,
    disabled,
    error,
    inputUse,
    onBlur,
    onChange,
    readOnly,
    value: initialDuration,
    field
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const isDate = field.type === DATE;
  const langKey = 'customerDataFiltersUI.customerDataFilters.FilterOperatorDurationInput.DurationUnits';
  const initialUnit = !initialDuration || isDate ? FQF_TIME_UNITS.days : getDefaultUnit(initialDuration);
  const [currentUnit, updateCurrentUnit] = useState(initialUnit);
  const [durationInput, updateDurationInput] = useState(formatDurationToUnit(initialDuration, initialUnit));
  const durationUnitOptions = isDate ? [{
    text: I18n.text(`${langKey}.days`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.days
  }] : [{
    text: I18n.text(`${langKey}.days`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.days
  }, {
    text: I18n.text(`${langKey}.hours`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.hours
  }, {
    text: I18n.text(`${langKey}.minutes`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.minutes
  }, {
    text: I18n.text(`${langKey}.seconds`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.seconds
  }];
  const handleValueChange = event => {
    let {
      target: {
        value
      }
    } = event;
    if (typeof value !== 'number') {
      onChange(syntheticEvent(null));
      return;
    }

    /*
     * When UINumberInput uses precision: 0, it only resets the value to an integer onBlur.
     * This ensures that the value is an integer without onBlur having been called
     */
    if (!Number.isInteger(value)) {
      value = Math.floor(value);
    }
    const valueInMilliseconds = Math.floor(formatDurationToMilliseconds(value, currentUnit));
    updateDurationInput(value);
    onChange(syntheticEvent(valueInMilliseconds));
  };
  const handleUnitChange = event => {
    const {
      target: {
        value
      }
    } = event;
    updateCurrentUnit(value);
    if (typeof durationInput !== 'number') {
      onChange(syntheticEvent(null));
      return;
    }
    const valueInMilliseconds = Math.floor(formatDurationToMilliseconds(durationInput, value));
    onChange(syntheticEvent(valueInMilliseconds));
  };
  return /*#__PURE__*/_jsxs(UIInputGroup, {
    use: "itemRight",
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputAreaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(UINumberInput, {
        "data-selenium-info": "date-duration",
        "data-selenium-test": dataSeleniumTest,
        disabled: disabled,
        precision: 0,
        formatter: value => value != null ? I18n.formatNumber(value, {
          precision: 0
        }) : '',
        onBlur: onBlur,
        onChange: handleValueChange,
        readOnly: readOnly,
        value: durationInput
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputAreaLabel'),
      children: /*#__PURE__*/_jsx(UISelect, {
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
        clearable: false,
        "data-selenium-info": "unit",
        "data-selenium-test": dataSeleniumTest,
        disabled: disabled,
        onChange: handleUnitChange,
        options: durationUnitOptions,
        readOnly: readOnly || isDate,
        value: currentUnit
      })
    })]
  });
};
export default FilterOperatorDateDurationInput;